import { gql } from "@apollo/client";

export const PORTAL_LOGIN_MUTATION = gql`
  mutation PortalLogin($login: String!, $password: String!) {
    portalLogin(login: $login, password: $password) {
      id
      name
      email
      login
      system_role
    }
  }
`;